module.exports = __webpack_public_path__ + "img/sv.a3d08972.png";